/* The FAQ closes the page: the bottom spacing the Mobile / Main boards give
   their last section. `section.` outranks the Section module's own padding
   whatever the CSS order. */
section.last {
  padding-bottom: 52px;
}

/* "Good to know": one column on phones, four from 1024 px. */
.tips {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 14px;
}

.tip {
  padding: 18px 20px;
  background: var(--band);
  border-radius: var(--radius-card);
}

.tipTitle {
  margin: 0 0 8px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.05;
}

.tipText {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-secondary);
}

@media (min-width: 1024px) {
  section.last {
    padding-bottom: 80px;
  }

  .tips {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
  }

  .tip {
    padding: 24px 26px;
  }

  .tipTitle {
    font-size: 27px;
  }

  .tipText {
    font-size: 14px;
  }
}
